import * as d3 from 'd3-selection'

const padding = 10
    , width = 7 // width of the triangle
    , height = 11 // height of the triangle
    , y = 13 // padding at the top of the arrow

export default function (selection, xScale, dimensions) {

  selection.each(function (data) {
    var indicator = d3.select(this)
                      .selectAll('path.gantt-offscreen-indicator')
                      .data(d => {
                        var offset = d.type === 'milestone' ? dimensions.milestone.rotatedHeight / 2 : 0

                        if (xScale(d._gantt.descendantsExtent[1]) + offset < xScale.range()[0]) {
                          // This drawing is off the screen to the left
                          return [`translate(${xScale.range()[0] + padding}, ${y}) rotate(180, ${width / 2}, ${height / 2})`]
                        }
                        if (xScale(d._gantt.descendantsExtent[0]) - offset > xScale.range()[1]) {
                          // Off the screen to the right
                          return [`translate(${xScale.range()[1] - padding - width}, ${y})`]
                        }
                        return []
                      })

    indicator.exit()
             .remove()

    indicator.enter()
             .append('path')
             .attr('class', 'gantt-offscreen-indicator')
             .attr('d', 'M6.69 6.252c-.007.008-.017.012-.025.02l-4.72 4.418a1.174 1.174 0 0 1-1.581 0 1.022 1.022 0 0 1-.316-.586c-.05-.317-.063-8.858-.03-9.162C.045.71.153.485.343.308a1.176 1.176 0 0 1 1.587 0l4.754 4.45c.228.212.337.48.337.75 0 .269-.11.538-.33.744z') // SVG of the sideways arrow with a rounded tip
             .merge(d3.select(this).selectAll('path.gantt-offscreen-indicator'))
             .attr('transform', String)
  })
}
